import {
  AlignItems,
  Box,
  ColorPreset,
  FontWeight,
  Glyph,
  HoverEffect,
  Icon,
  JustifyContent,
  PlainButton,
  Space,
  Text,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import { Currency } from "src/common/currencies";
import { Country } from "src/config";

interface Props {
  addAccount: () => void;
  country: Country;
  currency: Currency;
}

const AdditionalCurrencyRow: React.FC<Props> = ({
  addAccount,
  country,
  currency,
}) => (
  <Box
    bg={ColorPreset.BackgroundLight_03}
    alignItems={AlignItems.Center}
    justifyContent={JustifyContent.SpaceBetween}
    layout="flex"
    borderRadius={1}
    gutterH={1.5}
    gutterV={1.5}
  >
    <Box>
      <Text size={3} weight={FontWeight.Bold}>
        {country.name}
      </Text>
    </Box>
    <Box>
      <PlainButton
        size={3}
        weight={FontWeight.Bold}
        effect={HoverEffect.TextDecoration}
        onClick={() => addAccount()}
      >
        <Icon size="12px" name={Glyph.Add} />
        <Space layout="inline" h={0.5} />
        <Trans id="setup.bank-details.additional-currency.add-payout-account">
          Add payout account {currency}
        </Trans>
      </PlainButton>
    </Box>
  </Box>
);

export default AdditionalCurrencyRow;
